import { Divider } from '@mui/material';
import { useNavigate } from 'react-router';
import AppMenuItem from '../ui/AppMenuItem';
import AppMenu from './AppMenu';
import { type SubmenuProps } from './submenu-props';

const CatalogosMenu = (props: SubmenuProps) => {
  const navigate = useNavigate();
  const goTo = (route: string) => {
    navigate(route);
    props.onClose();
  };

  return (
    <AppMenu anchorEl={props.anchorElem} open={!!props.anchorElem} onClose={props.onClose}>
      <AppMenuItem module="almacenes" onClick={() => goTo('/almacenes')}>
        Almacenes
      </AppMenuItem>
      <AppMenuItem module="articulos" onClick={() => goTo('/articulos')}>
        Artículos
      </AppMenuItem>
      <AppMenuItem module="proveedores" onClick={() => goTo('/proveedores')}>
        Proveedores
      </AppMenuItem>
      <Divider />
      <AppMenuItem module="usuarios" onClick={() => goTo('/usuarios')}>
        Usuarios
      </AppMenuItem>
      <AppMenuItem module="perfiles" onClick={() => goTo('/perfiles')}>
        Perfiles
      </AppMenuItem>
    </AppMenu>
  );
};

export default CatalogosMenu;
